import { createBrowserRouter, Navigate } from "react-router-dom";
import { AccountCreation } from "./pages/Account";
import { AppCreation } from "./pages/AppCreation";
import { AuthLayout } from "./layouts/AuthLayout";
import { AppCreationLayout } from "./layouts/AppCreationLayout";
const router = createBrowserRouter([
  {
    path: "/auth",
    element: <AuthLayout />,
    children: [
      {
        path: "",
        element: <AccountCreation />,
      },
    ],
  },
  {
    path: "/app-creation",
    element: <AppCreationLayout />,
    children: [
      {
        path: "",
        element: <AppCreation />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to={"/auth"} />,
  },
]);

export default router;
